import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';

function Info() {
  const form = useRef();
  const [isSent, setIsSent] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_w88rpbs',     // 🔁 Replace with your EmailJS service ID
        'template_96dw1mp',    // 🔁 Replace with your EmailJS template ID
        form.current,
        'MsDgMpjueoDBipt2R'      // 🔁 Replace with your EmailJS public key
      )
      .then(
        (result) => {
          console.log(result.text);
          setIsSent(true);
          form.current.reset(); // Clear form
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div className="sec-box contact section-padding bord-thin-top" id="info">
      <div className="row">
        <div className="col-lg-5">
          <div className="sec-head md-mb80 wow fadeIn">
            <h6 className="sub-title mb-15 opacity-7">Get In Touch</h6>
            <h2 className="fz-50">Code that scales. Interfaces that engage!</h2>
            <p className="fz-15 mt-10">
              If you would like to work with me or just want to get in touch,
              I’d love to hear from you!
            </p>
            <div className="phone fz-30 fw-600 mt-30 underline">
              <a href="#0" className="main-color">
                +63 977 044 1301
              </a>
            </div>
            <ul className="rest social-text d-flex mt-60">
              <li className="mr-30">
                <a href="https://web.facebook.com/clarissa.vega.14224" className="hover-this">
                  <span className="hover-anim">Facebook</span>
                </a>
              </li>
              <li className="mr-30">
                <a href="https://www.linkedin.com/in/clarissa-vega-10600521a/" className="hover-this">
                  <span className="hover-anim">LinkedIn</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-lg-7 valign">
          <div className="full-width wow fadeIn">
            <form ref={form} onSubmit={sendEmail}>
              <div className="controls row">
                <div className="col-lg-6">
                  <div className="form-group mb-30">
                    <input
                      id="form_name"
                      type="text"
                      name="user_name"
                      placeholder="Name"
                      required
                    />
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="form-group mb-30">
                    <input
                      id="form_email"
                      type="email"
                      name="user_email"
                      placeholder="Email"
                      required
                    />
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-group mb-30">
                    <input
                      id="form_subject"
                      type="text"
                      name="subject"
                      placeholder="Subject"
                    />
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-group">
                    <textarea
                      id="form_message"
                      name="message"
                      placeholder="Message"
                      rows="4"
                      required
                    ></textarea>
                  </div>
                  <div className="mt-30">
                    <button type="submit">
                      <span className="text">Send A Message</span>
                    </button>
                  </div>
                  {isSent && (
                    <div className="mt-20" style={{ color: 'main-color' }}>
                      Message sent successfully!
                    </div>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Info;
